import script from "./AdminModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminModal.vue?vue&type=style&index=0&id=2c5840d5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5840d5"]])

export default __exports__